export const GET_MODEL_SUCCESS = "GET_MODEL_SUCCESS";
